import { axios, Response } from '../index'

type Body = {
  whoReceivedInviteId: string
}

const invitePersonaToGroup = (groupId: string, body: Body): Response<Body> => {
  return axios.post(`/v1/groups/${groupId}/invite`, body)
}

export default invitePersonaToGroup
